<template>
	<div class="comp-file-preview" v-if="isShow">
		<div class="comp-file-preview-box" @keyup="arrowGoPage($event)" tabindex="1">
			<div class="comp-file-preview-detail" v-if="type == 'image'">
				<div class="comp-file-preview-img-wrap">
					<img :src="showList[index].url" alt="">
				</div>
				<div class="comp-file-preview-prev" @click="prev"></div>
				<div class="comp-file-preview-next" @click="next"></div>
				<div class="comp-file-preview-desc">
					<p>总共<span>{{orgList.length}}</span>图片，当前第<span>{{(page - 1) * pageNum + index + 1}}</span>个</p>
				</div>
			</div>
			<div class="comp-file-preview-detail" v-else-if="type == 'video'">
				<video :src="showList[index].url" controls="" autoplay=""></video>
			</div>
			<div class="comp-file-preview-thumbs">
				<div class="comp-file-pt-prev" :class="{'comp-file-pt-prev-active' : page != 1}" @click="goPrevPage"></div>
				<div class="comp-file-pt-box">
					<div class="comp-file-pt-img-wrap" id="comp-file-pt-img-wrap">
						<img :src="img.thumbUrl" alt="" v-for="(img,key) in showList" @click="thumbClick(key)" :class="{'comp-file-pt-img-active' : index == key}">
					</div>
				</div>
				<div class="comp-file-pt-next" :class="{'comp-file-pt-next-active' : page != pages}" @click="goNextPage"></div>
			</div>
			<div class="comp-file-preview-close" @click="isShow = false"></div>
		</div>
	</div>
</template>

<script>
	import AppConfig from '../../config/AppConfig.js'
	
	export default{
		name:"FilePreview",
		data(){
			return{
				orgList:[],
				showList:[],
				pageNum: 8,
				page:1,
				pages:1,
				index: 0,
				isShow: false,
				type: ''
			}
		},
		
		methods:{
			// 缩略图点击
			thumbClick(index){
				this.index = index
			},
			
			// 初始化分页数据
			initPage(data,type,index){
				index = index + 1
				this.orgList = []
				this.showList = []
				if(type === 'image'){
					// 过滤图片,拿原图
					if(!data instanceof Array){
						return
					}
					for (var i = 0; i < data.length; i++) {
						let oUrl = data[i]
						if(oUrl.indexOf('http') === -1){
							  oUrl =  AppConfig.host + oUrl
						}
						this.orgList.push({
							url:oUrl.split("?x-oss-process")[0],
							thumbUrl:oUrl
						})
					}
				}else if(type === 'video'){
					this.orgList.push(data)
				}
				if(this.orgList.length === 0){
					return
				}
				this.pages = Math.ceil(this.orgList.length / this.pageNum)
				this.type = type
				// 根据index计算，当前页数，和实际再当页的index数值
				this.page = Math.ceil(index / this.pageNum)
				this.index = (index-1) % this.pageNum
				this.goPage()
				this.isShow = true
			},
			
			// 分页点击-跳转到第一页
			goFirstPage(){
				this.page = 1
				this.goPage()
				this.index = 0
			},
			
			// 分页点击-跳转到上一页
			goPrevPage(){
				if(this.page > 1){
					this.page--
					this.goPage()
					this.index = this.pageNum - 1
				}
			},
			
			// 分页点击-跳转到第一页
			goNextPage(){
				if(this.page < this.pages){
					this.page++
					this.goPage()
					this.index = 0
				}
			},
			
			// 分页点击-跳转到指定页
			goPage(page){
				if(page === undefined){
					page = this.page
				}
				if(page <= this.pages){
					this.showList = []
					for (var i = 0; i < this.pageNum; i++) {
						let img = this.orgList[i+(page-1) * this.pageNum]
						if(img !== undefined){
							this.showList.push(img)
						}
					}
				}	
			},
			
			// 当前页点击往上一个
			prev(){
				if(this.index > 0){
					this.index--
				}else{
					this.goPrevPage()
				}	
			},
			
			// 当前页点击往下一个
			next(){
				let pageNum = this.pageNum
				if(this.page == this.pages){
					pageNum = this.orgList.length % this.pageNum
					if(pageNum == 0){
						pageNum = this.pageNum
					}
				}
				if(this.index < pageNum-1){
					this.index++
				}else{
					this.goNextPage()
				}	
			},
			
			// 监听键盘事件，箭头控制分页，关闭页面
			arrowGoPage(event){
				if(event.code === 'ArrowLeft'){
					this.prev()
				}else if(event.code === 'ArrowRight'){
					this.next()
				}else if(event.code === 'Escape'){
					this.isShow = false
				}
			}
		},
		
		computed:{
			// 预览图数据
			fileList(){
				return this.$store.state.previewFile
			}
		},
		
		watch:{
			// 监听预览图的数据表
			fileList(nVal){
				this.initPage(nVal.data,nVal.type,nVal.index)
			}
		}
		
	}
</script>

<style>
	.comp-file-preview{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #000000a1;
		z-index: 999;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.comp-file-preview-box{
		position: relative;
		width: 710px;
		height: auto;
		background-color: #000000;
		padding: 15px;
	}
	.comp-file-preview-box:focus{
		border: none;
		outline: none;
	}
	.comp-file-preview-detail{
		width: 100%;
		min-height: 200px;
		max-height: 600px;
		position: relative;
		overflow: hidden;
	}
	.comp-file-preview-img-wrap{
		max-height: 600px;
		overflow: auto;
	}
	.comp-file-preview-img-wrap > img{
		margin: 0 auto;
		display: block;
		min-width: 240px;
		max-width: 100%;
		height: auto;
	}
	.comp-file-preview-detail > video{
		margin: 0 auto;
		display: block;
		min-width: 240px;
		max-width: 100%;
		height: auto;
		outline: none;
	}
	.comp-file-preview-prev{
		height: 100%;
		width: 300px;
		position: absolute;
		top: 0;
		left: 0;
		cursor: url("../assets/img/pic_prev.png"), pointer;
		opacity: 0;
	}
	.comp-file-preview-next{
		height: 100%;
		width: 300px;
		position: absolute;
		right: 0;
		top: 0;
		cursor: url("../assets/img/pic_next.png"), pointer;
		opacity: 0;
	}
	.comp-file-preview-desc{
		width: 100%;
		height: 24px;
		line-height: 24px;
		background-color: #000000a1;
		position: absolute;
		bottom: 0;
		left: 0;
		color: #d1d1d1;
		font-size: 12px;
	}
	.comp-file-preview-desc  span{
		font-weight: 600;
		display: inline-block;
		margin: 0 2px;
		color: #FFFFFF;
	}
	.comp-file-preview-thumbs{
		height: 70px;
		padding-top: 15px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.comp-file-preview-thumbs .comp-file-pt-prev{
		width: 20px;
		height: 50px;
		margin-right: 15px;
		background-image: url(../assets/img/prev-bf-48.png);
		background-position: center;
		background-size: 16px auto;
		background-repeat: no-repeat;
		background-color: #353535;
		cursor: pointer;
	}
	.comp-file-pt-prev-active{
		background-image: url(../assets/img/prev-42b983-48.png) !important;
	}
	.comp-file-preview-thumbs .comp-file-pt-box{
		width: 0;
		height: 70px;
		flex-grow: 1;
		overflow: hidden;
	}
	.comp-file-pt-img-wrap{
		width: 100%;
		height: 70px;
		overflow: hidden;
	}
	.comp-file-pt-img-wrap img{
		width: 64px;
		height: 64px;
		border: 3px solid #f1f1f1;
		margin: 0 5px;
		cursor: pointer;
	}
	.comp-file-pt-img-active{
		border: 3px solid #42b983 !important;
	}
	.comp-file-preview-thumbs .comp-file-pt-next{
		width: 20px;
		height: 50px;
		margin-left: 15px;
		background-image: url(../assets/img/next-bf-48.png);
		background-position: center;
		background-size: 16px auto;
		background-repeat: no-repeat;
		background-color: #353535;
		cursor: pointer;
	}
	.comp-file-pt-next-active{
		background-image: url(../assets/img/next-42b983-48.png) !important;
	}
	.comp-file-preview-close{
		width: 16px;
		height: 16px;
		position: absolute;
		top: -8px;
		right: -8px;
		border: 2px solid #000000;
		padding: 5px;
		background-color: #FFFFFF;
		border-radius: 50%;
		background-image: url(../assets/img/comp-close.png);
		background-position: center;
		background-size: 16px auto;
		background-repeat: no-repeat;
		cursor: pointer;
	}
</style>
